<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                <span>{{info.title}}</span>
            </div>
            <div class="right"></div>
        </div>
        <div>
			<div class="form-box">
				<p>2021年10月 共计2课时  合计课酬¥100.00</p>
				<!-- <el-button type="primary" size="small" @click='exportFun()'>导出</el-button> -->
			</div>

            <!-- 校内教师 -->
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
					<el-table-column type="index" label="序号" width="50" align="center">
					</el-table-column>
                    <el-table-column prop="date" label="服务日期" align="center">
                    </el-table-column>
                    <el-table-column prop="time" label="服务时段" align="center">
                    </el-table-column>
                    <el-table-column prop="course" label="授课课程" align="center">
                    </el-table-column>
                    <el-table-column prop="course_time" label="服务课时" align="center">
                    </el-table-column>
                    <el-table-column prop="class" label="服务班级" align="center">
                    </el-table-column>
					<el-table-column prop="money" label="课时课酬" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
	props:['info'],
	components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 2,
			queryParams: {
				name: '',
				title: '',
			},
			tableData: [
				{date:'2021.10.14',time:'16:00-17:00',course:'一知一行少儿国学',course_time:'1',class:'一年级1班',money:'¥50.00'},
				{date:'2021.10.14',time:'16:00-19:00',course:'一知一行少儿国学',course_time:'2',class:'一年级2班',money:'¥50.00'},
			],
		}
	},
	computed:{

	},
	watch: {
		'info.classId':function(n,o){
			this.pageNum = 1;
			// this.getDataList();
		},
	},
	created() {
		
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				page:this.pageNum,
				limit:this.pageSize,
				classId:this.info.classId,
				courseName:this.queryParams.title,
				studentName:this.queryParams.name,
			}
			// let res= await api.studentCourseStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
			// console.log('学生分布详情',res)
		},
		searchFun(){
			this.pageNum = 1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toIndex(){
            this.$emit('to-index')
        },
		exportFun(){},
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
			margin-right: 30px;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}
	.form-box{
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
		p{
			font-size: 18px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
